/**
 * Check if a value is defined
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
export default function isDefined(value) {
  return value !== undefined && value !== null;
}
